module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.16.2@axios/index.js
// module id = 97
// module chunks = 48